import {
    REQUEST_INVENTORY_REPACKAGES,
    FETCH_INVENTORY_REPACKAGES_SUCCESS,
    FETCH_INVENTORY_REPACKAGES_FAILURE,
    SELECT_INVENTORY_REPACKAGE,
    RESET_CURRENT_INVENTORY_REPACKAGE,
    REQUEST_INVENTORY_REPACKAGE_DETAIL,
    FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS,
    FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE,
    REQUEST_CREATING_INVENTORY_REPACKAGE,
    CREATE_INVENTORY_REPACKAGE_SUCCESS,
    CREATE_INVENTORY_REPACKAGE_FAILURE,
    REQUEST_EDITING_INVENTORY_REPACKAGE,
    EDIT_INVENTORY_REPACKAGE_SUCCESS,
    EDIT_INVENTORY_REPACKAGE_FAILURE
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentInventoryRepackage: null,
    currentInventoryRepackageDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    inventoryRepackageIsCreating: false,
    inventoryRepackageCreateError: null,
    inventoryRepackageCreated: false,
    inventoryRepackageIsEditing: false,
    inventoryRepackageEditError: null,
    inventoryRepackageEdited: false
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Inventory Relocation action handlers
        case REQUEST_INVENTORY_REPACKAGES:
            return { ...state, error: null, isLoading: true };
        case FETCH_INVENTORY_REPACKAGES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_INVENTORY_REPACKAGES_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_INVENTORY_REPACKAGE:
            return { ...state, currentInventoryRepackage: action.payload };
        case RESET_CURRENT_INVENTORY_REPACKAGE:
            return { ...state, currentInventoryRepackage: null, currentInventoryRepackageDetail: null };
        case REQUEST_INVENTORY_REPACKAGE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentInventoryRepackageDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_INVENTORY_REPACKAGE:
            return { ...state, inventoryRepackageIsCreating: true, inventoryRepackageCreateError: null, inventoryRepackageCreated: false };
        case CREATE_INVENTORY_REPACKAGE_SUCCESS:
            return { ...state, inventoryRepackageIsCreating: false, inventoryRepackageCreateError: null, inventoryRepackageCreated: true };
        case CREATE_INVENTORY_REPACKAGE_FAILURE:
            const inventoryRepackageCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, inventoryRepackageIsCreating: false, inventoryRepackageCreateError: inventoryRepackageCreateError, inventoryRepackageCreated: false };
        case REQUEST_EDITING_INVENTORY_REPACKAGE:
            return { ...state, inventoryRepackageIsEditing: true, inventoryRepackageEditError: null, inventoryRepackageEdited: false };
        case EDIT_INVENTORY_REPACKAGE_SUCCESS:
            return { ...state, inventoryRepackageIsEditing: false, inventoryRepackageEditError: null, inventoryRepackageEdited: true };
        case EDIT_INVENTORY_REPACKAGE_FAILURE:
            const inventoryRepackageEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, inventoryRepackageIsEditing: false, inventoryRepackageEditError: inventoryRepackageEditError, inventoryRepackageEdited: false };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/inventoryRepackages_reducer.js